/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cross': {
    width: 25,
    height: 25,
    viewBox: '-1 -1 24 24',
    data: '<path pid="0" class="st0" d="M10.8 8.1L2.7 0 0 2.7l8.1 8.1L0 19l2.7 2.7 8.1-8.2 8.2 8.2 2.7-2.7-8.2-8.2 8.2-8.1L19 0"/>'
  }
})
